import { render, staticRenderFns } from "./ToolLanding.vue?vue&type=template&id=0033616f&lang=pug"
import script from "./ToolLanding.vue?vue&type=script&lang=js"
export * from "./ToolLanding.vue?vue&type=script&lang=js"
import style0 from "./ToolLanding.vue?vue&type=style&index=0&id=0033616f&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoverlyHeading: require('/app/components/elements/typography/Heading.vue').default,LoverlyIcon: require('/app/components/elements/typography/Icon.vue').default,LoverlyJsonForm: require('/app/components/forms/JsonForm.vue').default,LoverlyButton: require('/app/components/inputs/Button.vue').default,LoverlyJsonPage: require('/app/components/pageComponents/JsonPage.vue').default,LoverlyFeatureSection: require('/app/components/blocks/FeatureSection.vue').default,LoverlyAccordion: require('/app/components/elements/Accordion.vue').default,LoverlyToolCard: require('/app/components/pages/dashboard/ToolCard.vue').default,LoverlyCarousel: require('/app/components/elements/containers/Carousel.vue').default,LoverlyLoginRegisterForm: require('/app/components/forms/LoginRegisterForm.vue').default,LoverlyModal: require('/app/components/elements/Modal.vue').default})
